import React, {Suspense} from 'react';
import { createRoot } from 'react-dom/client';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from "react-router-dom";

import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import './i18n';
import './assets/css/style.scss';
import { ComponentsLoader } from 'components';
import 'preline/preline'
import store from './redux/store';
import App from './App';

(function redirectToBasePath() {
    const isNotEmptyBasePath = process.env.REACT_APP_BASE_PATH?.length > 1
    const path = window.location.pathname;
    if (isNotEmptyBasePath && path === '/') {
        window.location.pathname = process.env.REACT_APP_BASE_PATH;
    }
})();
const root = createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Router basename={process.env.REACT_APP_BASE_PATH}>
            <Provider store={store}>
                <Suspense fallback={<div>Loading...</div>}>
                    <App />
                </Suspense>
            </Provider>
        </Router>
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
